import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const menuItems = [
  {
    title: 'Dar de alta alumno',
    description: 'Registra nuevos alumnos al sistema',
    buttonText: 'Dar de alta alumno',
    route: '/register',
    icon: '👤'
  },
  {
    title: 'Ver todos los alumnos',
    description: 'Consulta, edita o elimina registros existentes',
    buttonText: 'Ver todos los alumnos',
    route: '/members',
    icon: '👥'
  },
  {
    title: 'Asignar rutinas',
    description: 'Asigna planes de entrenamiento personalizados',
    buttonText: 'Asignar rutinas',
    route: '/routines',
    icon: '💪'
  },
  {
    title: 'Dietas',
    description: 'Creá planes de alimentación y compartí un enlace con cada alumno',
    buttonText: 'Gestionar dietas',
    route: '/dietas',
    icon: '🥗'
  },
  {
    title: 'Estadísticas de horarios',
    description: 'Visualiza picos y comportamiento de asistencia',
    buttonText: 'Estadísticas de horarios',
    route: '/stats',
    icon: '📊'
  },
  {
    title: 'Login Manual',
    description: 'Accede con credenciales sin escaneo ni app',
    buttonText: 'Login Manual',
    route: '/login',
    icon: '🔐'
  },
  {
    title: 'Alias de pagos',
    description: 'Consulta y gestiona los alias de cobro',
    buttonText: 'Alias de pagos',
    route: '/payment',
    icon: '💳'
  },
  {
    title: 'Ingresos y gastos',
    description: 'Controla la caja, cuotas, ingresos extra y gastos',
    buttonText: 'Ver caja',
    route: '/finances',
    icon: '💰'
  },
  {
    title: 'Reportes',
    description: 'Genera y consulta reportes del gimnasio',
    buttonText: 'Ver reportes',
    route: '/reports',
    icon: '📋'
  },
  {
    title: 'Asistencias',
    description: 'Genera y consulta reportes de asistencias',
    buttonText: 'Ver asistencias',
    route: '/assistance',
    icon: '📋'
  },
  {
    title: 'Analisis del gym',
    description: 'Estadisticas y datos del gimnasio',
    buttonText: 'Ver datos',
    route: '/data',
    icon: '📋'
  },
];

const Dashboard = () => {
  const location = useLocation();
  const username = location.state?.username || 'Administrador';

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa', padding: '20px' }}>
      <div style={{
        backgroundColor: '#4472c4',
        color: 'white',
        padding: '20px',
        borderRadius: '8px 8px 0 0',
        marginBottom: '0',
        display: 'flex',
        alignItems: 'center',
        gap: '15px'
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '50%',
          width: '50px',
          height: '50px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '24px'
        }}>
          🏋️
        </div>
        <div>
          <h2 style={{ margin: 0, fontSize: '24px' }}>
            {username}, Bienvenido al Panel de Administración
          </h2>
        </div>
      </div>

      <div style={{
        backgroundColor: '#5b7db1',
        color: 'white',
        padding: '12px 20px',
        textAlign: 'center',
        fontSize: '16px',
        fontWeight: '500'
      }}>
        Elija la tarea a realizar
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '20px',
        padding: '30px 20px',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        {menuItems.map((item, index) => (
          <div
            key={index}
            style={{
              backgroundColor: 'white',
              border: '2px solid #e0e0e0',
              borderRadius: '8px',
              padding: '25px',
              textAlign: 'center',
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.12)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
            }}
          >
            <div style={{ fontSize: '32px', marginBottom: '15px' }}>
              {item.icon}
            </div>

            <h3 style={{
              fontSize: '18px',
              fontWeight: 'bold',
              color: '#333',
              marginBottom: '10px',
              lineHeight: '1.3'
            }}>
              {item.title}
            </h3>

            <p style={{
              fontSize: '14px',
              color: '#666',
              marginBottom: '20px',
              lineHeight: '1.4'
            }}>
              {item.description}
            </p>

            <Link to={item.route} style={{ textDecoration: 'none' }}>
              <button
                style={{
                  backgroundColor: '#4472c4',
                  color: 'white',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '6px',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'background-color 0.3s ease',
                  minWidth: '180px'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#365a96'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#4472c4'}
              >
                {item.buttonText}
              </button>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
